import React from 'react';
import CompanyChangeRegisterDataConsult from './Company';

const ChangeRegisterDataConsult: React.FC = () => {
  return <CompanyChangeRegisterDataConsult />;
};

export default ChangeRegisterDataConsult;
